import cx from 'classnames'
import Link from 'next/link'

import { useSessionQueryState } from '@/api'
import { Loader } from '@/components/Loader'
import { useIsLoggedIn } from '@/features/common/useIsLoggedIn'
import { LoginButton } from '@/features/header/LoginButton'
import { UserAvatarImage } from '@/features/user/avatar/UserAvatarImage'
import { LOGIN_STATUS } from '@/features/user/userSlice'
import { COLOR_GRAY } from '@/utils/styles'
import { useAppSelector } from '@/utils/useAppSelector'

import styles from './menuUser.module.scss'

export const MenuUser: React.FC<{ loginStatus: LOGIN_STATUS }> = ({ loginStatus }) => {
  const isLoggedIn = useIsLoggedIn()
  const isLoading = useSessionQueryState().isLoading
  const username = useAppSelector((state) => state.user.profile?.profile?.name)
  const userUninitialized = loginStatus === LOGIN_STATUS.SSO_LOGIN_MIGHT_HAPPEN
  if (isLoading || userUninitialized) {
    return (
      <div className={styles.user}>
        <Loader strokeColor={COLOR_GRAY} dataCy="header-user-loading" />
      </div>
    )
  }
  if (!isLoggedIn) {
    return (
      <div className={cx(styles.user, styles.loggedOut)}>
        <LoginButton additionalClasses={styles.loginButton} data-cy="header-login" />
      </div>
    )
  }

  return (
    <Link href="/account" className={styles.user}>
      <div>
        <div className={styles.userDetails} data-cy="header-user-avatar">
          <UserAvatarImage
            showSCIDIcon
            showOutline
            className={styles.userAvatar}
            layout="fill"
            quality={100}
            objectFit="contain"
          />
          <div>{username}</div>
        </div>
      </div>
      <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L6 6L1 11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Link>
  )
}
